import { NgModule } from '@angular/core';
import { DsLibMaterialModule } from '../../../shared/ds-lib-material.module';
import { DsLibHelpComponent } from './ds-lib-help.component';

@NgModule({
  declarations: [DsLibHelpComponent],
  imports: [DsLibMaterialModule],
  exports: [DsLibHelpComponent],
})
export class DsLibHelpModule {}
